import { render, staticRenderFns } from "./ButtonBlockContainer.vue?vue&type=template&id=195a212e&"
import script from "./ButtonBlockContainer.vue?vue&type=script&lang=js&"
export * from "./ButtonBlockContainer.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBlockContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports